// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import * as XLSX from "xlsx";
// import Layouts from "../../layouts/layouts";
// import DataTable_Component from "../../components/salaryverification/Data Table";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTrash,
//   faEye,
//   faUpload,
//   faDownload,
// } from "@fortawesome/free-solid-svg-icons";

// const getPreviousMonth = () => {
//   const today = new Date();
//   today.setMonth(today.getMonth() - 1);
//   return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
//     2,
//     "0"
//   )}`;
// };

// export default function SalaryVerification() {
//   const title = "Salary Verification";
//   const [reports, setReports] = useState([]);
//   const [file, setFile] = useState(null);
//   const [month, setMonth] = useState(getPreviousMonth());
//   const [loading, setLoading] = useState(false);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const token = localStorage.getItem("token");

//   // ✅ Fetch all reports
//   const fetchReports = async () => {
//     try {
//       const { data } = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/salary/reports`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setReports(data.reports || []);
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//       Swal.fire("Error", "Failed to fetch salary reports", "error");
//     }
//   };

//   // ✅ Upload new salary sheet
//   const handleUpload = async (e) => {
//     e.preventDefault();
//     if (!file) return Swal.fire("Warning", "Please select a file", "warning");

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("month", month);

//     try {
//       setLoading(true);
//       const { data } = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/salary/validate-salary`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       Swal.fire(
//         "Success",
//         data.message || "File uploaded successfully",
//         "success"
//       );
//       setFile(null);
//       fetchReports();
//     } catch (error) {
//       console.error(error);
//       Swal.fire(
//         "Error",
//         error.response?.data?.message || "Error uploading file",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Delete report
//   const deleteReport = async (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This will permanently delete the report!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(
//             `${process.env.REACT_APP_BASE_URL}/api/v1/salary/reports/${id}`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );
//           Swal.fire("Deleted!", "Report deleted successfully", "success");
//           fetchReports();
//         } catch (error) {
//           Swal.fire("Error", "Failed to delete report", "error");
//         }
//       }
//     });
//   };

//   const exportReport = (report) => {
//     if (!report.results || report.results.length === 0) {
//       return Swal.fire("Info", "No data available in this report", "info");
//     }

//     // 🧠 Preprocess the data to flatten arrays and nested fields
//     const formattedResults = report.results.map((r) => ({
//       EmployeeID: r.employeeId,
//       JoiningDate: r.joiningDate
//         ? new Date(r.joiningDate).toLocaleDateString()
//         : "-",
//       ClientName: r.clientName || "-",
//       Name: r.name,
//       AccountNumber: r.accountNumber,
//       Status: r.status,
//       Issues: Array.isArray(r.issues) ? r.issues.join(", ") : r.issues || "-",
//     }));

//     // ✅ Create Excel sheet from formatted data
//     const worksheet = XLSX.utils.json_to_sheet(formattedResults);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Report");

//     XLSX.writeFile(workbook, `${report.fileName}_Report.xlsx`);
//   };

//   useEffect(() => {
//     fetchReports();
//   }, []);

//   // ✅ Table columns
//   const columns = [
//     { name: <b>File Name</b>, selector: (row) => row.fileName, sortable: true },
//     { name: <b>Month</b>, selector: (row) => row.report_month, sortable: true },
//     {
//       name: <b>Total Records</b>,
//       selector: (row) => row.totalRecords,
//       sortable: true,
//     },
//     {
//       name: <b>Created At</b>,
//       selector: (row) => new Date(row.createdAt).toLocaleString(),
//       sortable: true,
//     },
//     {
//       name: <b>Actions</b>,
//       cell: (row) => (
//         <>
//           <button
//             className="btn btn-primary btn-sm me-1"
//             onClick={() => setSelectedReport(row)}
//             title="View Details"
//           >
//             <FontAwesomeIcon icon={faEye} />
//           </button>
//           <button
//             className="btn btn-success btn-sm me-1"
//             onClick={() => exportReport(row)}
//             title="Download Report"
//           >
//             <FontAwesomeIcon icon={faDownload} />
//           </button>
//           <button
//             className="btn btn-danger btn-sm"
//             onClick={() => deleteReport(row._id)}
//             title="Delete Report"
//           >
//             <FontAwesomeIcon icon={faTrash} />
//           </button>
//         </>
//       ),
//     },
//   ];

//   // ✅ Summary Calculations (when report selected)
//   const totalRecords = selectedReport?.results?.length || 0;
//   const passedCount =
//     selectedReport?.results?.filter((r) => r.status === "PASSED").length || 0;
//   const failedCount = totalRecords - passedCount;
//   const passedPercentage = totalRecords
//     ? ((passedCount / totalRecords) * 100).toFixed(1)
//     : 0;
//   const failedPercentage = totalRecords
//     ? ((failedCount / totalRecords) * 100).toFixed(1)
//     : 0;
//   const [sortOrder, setSortOrder] = useState("asc");

//   const sortedResults = selectedReport?.results
//     ? [...selectedReport.results].sort((a, b) => {
//         if (sortOrder === "asc") {
//           return a.status.localeCompare(b.status);
//         } else {
//           return b.status.localeCompare(a.status);
//         }
//       })
//     : [];

//   return (
//     <>
//       <Layouts />
//       <div className="container-fluid my-3">
//         <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
//           <div className="card-header d-flex justify-content-between align-items-center">
//             <h4>{title}</h4>

//             {/* Upload Form */}
//             <form
//               onSubmit={handleUpload}
//               className="d-flex align-items-center gap-2"
//             >
//               <input
//                 type="month"
//                 value={month}
//                 onChange={(e) => setMonth(e.target.value)}
//                 className="form-control form-control-sm"
//                 style={{ width: "160px" }}
//               />
//               <input
//                 type="file"
//                 accept=".xlsx, .xls"
//                 onChange={(e) => setFile(e.target.files[0])}
//                 className="form-control form-control-sm"
//               />
//               <button
//                 type="submit"
//                 className="btn btn-primary btn-sm text-white"
//                 disabled={loading}
//               >
//                 <FontAwesomeIcon icon={faUpload} />{" "}
//                 {loading ? "Uploading..." : "Upload"}
//               </button>
//             </form>
//           </div>

//           {/* Data Table */}
//           <div className="card-body">
//             {reports.length > 0 ? (
//               <DataTable_Component
//                 apidata={reports}
//                 columns={columns}
//                 searchBy="fileName"
//               />
//             ) : (
//               <p>Loading reports or no data found...</p>
//             )}
//           </div>
//         </div>

//         {/* Selected Report Details */}
//         {selectedReport && (
//           <div className="card mt-3">
//             <div className="card-header d-flex justify-content-between align-items-center">
//               <h5>
//                 Report Details — <b>{selectedReport.fileName}</b>
//               </h5>
//               <button
//                 className="btn btn-secondary btn-sm"
//                 onClick={() => setSelectedReport(null)}
//               >
//                 Close
//               </button>
//             </div>

//             {/* ✅ Summary Overview Section */}
//             <div className="d-flex justify-content-around text-center my-3">
//               <div className="p-2 bg-light rounded shadow-sm w-25">
//                 <h6 className="text-success mb-1">✅ Passed</h6>
//                 <h5 className="fw-bold text-success">
//                   {passedCount} ({passedPercentage}%)
//                 </h5>
//               </div>
//               <div className="p-2 bg-light rounded shadow-sm w-25">
//                 <h6 className="text-danger mb-1">❌ Failed</h6>
//                 <h5 className="fw-bold text-danger">
//                   {failedCount} ({failedPercentage}%)
//                 </h5>
//               </div>
//               <div className="p-2 bg-light rounded shadow-sm w-25">
//                 <h6 className="text-primary mb-1">📊 Total Records</h6>
//                 <h5 className="fw-bold text-primary">{totalRecords}</h5>
//               </div>
//             </div>

//             {/* ✅ Report Table */}
//             <div className="card-body table-responsive">
//               <table className="table table-bordered table-sm">
//                 <thead className="table-light">
//                   <tr>
//                     <th>Employee ID</th>
//                     <th>Joining Date</th>
//                     <th>Client Name</th>
//                     <th>Name</th>
//                     <th>Account Number</th>
//                     {/* <th>Status</th> */}
//                     <th
//                       style={{ cursor: "pointer" }}
//                       onClick={() => {
//                         setSortOrder((prev) =>
//                           prev === "asc" ? "desc" : "asc"
//                         );
//                       }}
//                     >
//                       Status {sortOrder === "asc" ? "▲" : "▼"}
//                     </th>
//                     <th>Issues</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {sortedResults.map((r, i) => (
//                     <tr key={i}>
//                       <td>{r.employeeId}</td>
//                       <td>
//                         {r.joiningDate
//                           ? new Date(r.joiningDate).toLocaleDateString()
//                           : "-"}
//                       </td>
//                       <td>{r.clientName || "-"}</td>
//                       <td>{r.name}</td>
//                       <td>{r.accountNumber}</td>
//                       <td>
//                         <span
//                           className={`badge ${
//                             r.status === "PASSED" ? "bg-success" : "bg-danger"
//                           }`}
//                         >
//                           {r.status}
//                         </span>
//                       </td>
//                       <td>
//                         {r.issues && r.issues.length
//                           ? r.issues.join(", ")
//                           : "-"}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import Layouts from "../../layouts/layouts";
import DataTable_Component from "../../components/salaryverification/Data Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEye,
  faUpload,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

const getPreviousMonth = () => {
  const today = new Date();
  today.setMonth(today.getMonth() - 1);
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
    2,
    "0"
  )}`;
};

export default function SalaryVerification() {
  const title = "Salary Verification";
  const [reports, setReports] = useState([]);
  const [file, setFile] = useState(null);
  const [month, setMonth] = useState(getPreviousMonth());
  const [loading, setLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: "asc",
  });

  const token = localStorage.getItem("token");

  const [showDuplicates, setShowDuplicates] = useState(false);

  const getFormattedDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`; // or dd-mm-yyyy
  };

  // Fetch all reports
  const fetchReports = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/salary/reports`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReports(data.reports || []);
    } catch (error) {
      console.error("Error fetching reports:", error);
      Swal.fire("Error", "Failed to fetch salary reports", "error");
    }
  };

  // Upload salary sheet
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return Swal.fire("Warning", "Please select a file", "warning");

    const formData = new FormData();
    // formData.append("file", file);
    // 🔥 Get today's date formatted
    const currentDate = getFormattedDate();

    // 🔥 Extract original filename
    const originalName = file.name;
    const ext = originalName.substring(originalName.lastIndexOf("."));
    const baseName = originalName.substring(0, originalName.lastIndexOf("."));

    // 🔥 New filename: Date_SheetName.ext
    const newFileName = `${currentDate}_${baseName}${ext}`;

    // 🔥 Create renamed file
    const renamedFile = new File([file], newFileName, { type: file.type });

    // Add renamed file instead of original
    formData.append("file", renamedFile);

    formData.append("month", month);

    try {
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/salary/validate-salary`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire(
        "Success",
        data.message || "File uploaded successfully",
        "success"
      );
      setFile(null);
      fetchReports();
    } catch (error) {
      console.error(error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Error uploading file",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete report
  const deleteReport = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the report!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(
            `${process.env.REACT_APP_BASE_URL}/api/v1/salary/reports/${id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          Swal.fire("Deleted!", "Report deleted successfully", "success");
          fetchReports();
        } catch (error) {
          Swal.fire("Error", "Failed to delete report", "error");
        }
      }
    });
  };

  const exportReport = (report) => {
    if (!report.results || report.results.length === 0) {
      return Swal.fire("Info", "No data available in this report", "info");
    }

    const formattedResults = report.results.map((r) => ({
      EmployeeID: r.employeeId,
      Trips: r.trips || 0,
      JoiningDate: r.joiningDate
        ? new Date(r.joiningDate).toLocaleDateString()
        : "-",
      ClientName: r.clientName || "-",
      SalaryBasic: r.salaryBasic || 0,
      Name: r.name,
      AccountNumber: r.accountNumber,
      Status: r.status,
      Issues: Array.isArray(r.issues) ? r.issues.join(", ") : r.issues || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedResults);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Report");

    XLSX.writeFile(workbook, `${report.fileName}_Report.xlsx`);
  };

  useEffect(() => {
    fetchReports();
  }, []);

  // Table columns
  const columns = [
    { name: <b>File Name</b>, selector: (row) => row.fileName, sortable: true },
    { name: <b>Month</b>, selector: (row) => row.report_month, sortable: true },
    {
      name: <b>Total Records</b>,
      selector: (row) => row.totalRecords,
      sortable: true,
    },
    {
      name: <b>Created At</b>,
      selector: (row) => new Date(row.createdAt).toLocaleString(),
      sortable: true,
    },
    {
      name: <b>Actions</b>,
      cell: (row) => (
        <>
          <button
            className="btn btn-primary btn-sm me-1"
            onClick={() => setSelectedReport(row)}
            title="View Details"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
          <button
            className="btn btn-success btn-sm me-1"
            onClick={() => exportReport(row)}
            title="Download Report"
          >
            <FontAwesomeIcon icon={faDownload} />
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => deleteReport(row._id)}
            title="Delete Report"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      ),
    },
  ];

  // Summary calculations
  const totalRecords = selectedReport?.results?.length || 0;
  const passedCount =
    selectedReport?.results?.filter((r) => r.status === "PASSED").length || 0;
  const failedCount = totalRecords - passedCount;

  const passedPercentage = totalRecords
    ? ((passedCount / totalRecords) * 100).toFixed(1)
    : 0;
  const failedPercentage = totalRecords
    ? ((failedCount / totalRecords) * 100).toFixed(1)
    : 0;

  const [sortOrder, setSortOrder] = useState("asc");

  // const sortedResults = selectedReport?.results
  //   ? [...selectedReport.results].sort((a, b) => {
  //       if (sortOrder === "asc") {
  //         return a.status.localeCompare(b.status);
  //       } else {
  //         return b.status.localeCompare(a.status);
  //       }
  //     })
  //   : [];
  const sortedResults = selectedReport?.results
    ? [...selectedReport.results].sort((a, b) => {
        if (!sortConfig.column) return 0;

        let valA = a[sortConfig.column];
        let valB = b[sortConfig.column];

        // Normalize undefined/null
        valA = valA ?? "";
        valB = valB ?? "";

        // Date sort
        if (sortConfig.column === "joiningDate") {
          return sortConfig.direction === "asc"
            ? new Date(valA) - new Date(valB)
            : new Date(valB) - new Date(valA);
        }

        // Numeric sort
        if (typeof valA === "number" && typeof valB === "number") {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }

        // String sort
        return sortConfig.direction === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      })
    : [];

  // -------------------------
  // 🔥 DUPLICATE LOGIC ADDED
  // -------------------------
  const duplicatesMap = {};
  selectedReport?.results?.forEach((r) => {
    duplicatesMap[r.employeeId] = (duplicatesMap[r.employeeId] || 0) + 1;
  });

  const duplicateEntries = selectedReport?.results?.filter(
    (r) => duplicatesMap[r.employeeId] > 1
  );

  const duplicateCount = duplicateEntries?.length || 0;
  const sortedDuplicates = duplicateEntries
    ? [...duplicateEntries].sort((a, b) =>
        sortOrder === "asc"
          ? a.status.localeCompare(b.status)
          : b.status.localeCompare(a.status)
      )
    : [];

  const salaryShown = {};

  const handleSort = (column) => {
    setSortConfig((prev) => ({
      column,
      direction:
        prev.column === column && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid my-3">
        <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>{title}</h4>

            <form
              onSubmit={handleUpload}
              className="d-flex align-items-center gap-2"
            >
              <input
                type="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className="form-control form-control-sm"
                style={{ width: "160px" }}
              />
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={(e) => setFile(e.target.files[0])}
                className="form-control form-control-sm"
              />
              <button
                type="submit"
                className="btn btn-primary btn-sm text-white"
                disabled={loading}
              >
                <FontAwesomeIcon icon={faUpload} />{" "}
                {loading ? "Uploading..." : "Upload"}
              </button>
            </form>
          </div>

          <div className="card-body">
            {reports.length > 0 ? (
              <DataTable_Component
                apidata={reports}
                columns={columns}
                searchBy="fileName"
              />
            ) : (
              <p>Loading reports or no data found...</p>
            )}
          </div>
        </div>

        {selectedReport && (
          <div className="card mt-3">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5>
                Report Details — <b>{selectedReport.fileName}</b>
              </h5>

              <div>
                {showDuplicates && (
                  <button
                    className="btn btn-danger btn-sm me-2"
                    onClick={() => setShowDuplicates(false)}
                  >
                    Show All
                  </button>
                )}
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => setSelectedReport(null)}
                >
                  Close
                </button>
              </div>
            </div>

            {/* Summary Boxes */}
            <div className="d-flex justify-content-around text-center my-3 gap-4">
              <div className="p-2 bg-light rounded shadow-sm w-25">
                <h6 className="text-success mb-1">✅ Passed</h6>
                <h5 className="fw-bold text-success">
                  {passedCount} ({passedPercentage}%)
                </h5>
              </div>

              <div className="p-2 bg-light rounded shadow-sm w-25">
                <h6 className="text-danger mb-1">❌ Failed</h6>
                <h5 className="fw-bold text-danger">
                  {failedCount} ({failedPercentage}%)
                </h5>
              </div>

              {/* 🔥 DUPLICATE BOX */}
              <div
                className="p-2 bg-light rounded shadow-sm w-25"
                style={{ cursor: "pointer" }}
                onClick={() => setShowDuplicates(true)}
              >
                <h6 className="text-warning mb-1">⚠️ Duplicate</h6>
                <h5 className="fw-bold text-warning">{duplicateCount}</h5>
              </div>

              <div className="p-2 bg-light rounded shadow-sm w-25">
                <h6 className="text-primary mb-1">📊 Total Records</h6>
                <h5 className="fw-bold text-primary">{totalRecords}</h5>
              </div>
            </div>

            {/* Table */}
            <div className="card-body table-responsive">
              <table className="table table-bordered table-sm">
                <thead className="table-light">
                  <tr>
                    {/* <th>Employee ID</th> */}
                    <th
                      onClick={() => handleSort("employeeId")}
                      style={{ cursor: "pointer" }}
                    >
                      Employee ID
                      {sortConfig.column === "employeeId" &&
                        (sortConfig.direction === "asc" ? " ▲" : " ▼")}
                    </th>

                    {/* <th>Joining Date</th> */}
                    <th
                      onClick={() => handleSort("joiningDate")}
                      style={{ cursor: "pointer" }}
                    >
                      Joining Date
                      {sortConfig.column === "joiningDate" &&
                        (sortConfig.direction === "asc" ? " ▲" : " ▼")}
                    </th>

                    {/* <th>Client Name</th> */}
                    <th
                      onClick={() => handleSort("clientName")}
                      style={{ cursor: "pointer" }}
                    >
                      Client Name
                      {sortConfig.column === "clientName" &&
                        (sortConfig.direction === "asc" ? " ▲" : " ▼")}
                    </th>

                    <th>Name</th>
                    {/* <th>Trips</th> */}
                    <th
                      onClick={() => handleSort("trips")}
                      style={{ cursor: "pointer" }}
                    >
                      Trips
                      {sortConfig.column === "trips" &&
                        (sortConfig.direction === "asc" ? " ▲" : " ▼")}
                    </th>

                    {/* <th>Salary Basic</th> */}
                    <th
                      onClick={() => handleSort("salaryBasic")}
                      style={{ cursor: "pointer" }}
                    >
                      Salary Basic
                      {sortConfig.column === "salaryBasic" &&
                        (sortConfig.direction === "asc" ? " ▲" : " ▼")}
                    </th>

                    <th>Account Number</th>

                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSortOrder((prev) =>
                          prev === "asc" ? "desc" : "asc"
                        );
                      }}
                    >
                      Status {sortOrder === "asc" ? "▲" : "▼"}
                    </th>
                    <th>Issues</th>
                  </tr>
                </thead>

                <tbody>
                  {(showDuplicates ? sortedDuplicates : sortedResults).map(
                    (r, i) => (
                      <tr key={i}>
                        <td>{r.employeeId}</td>
                        <td>
                          {r.joiningDate
                            ? new Date(r.joiningDate).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>{r.clientName || "-"}</td>
                        <td>{r.name}</td>
                        <td>{r.trips || 0}</td> {/* ⭐ ADDED */}
                        {/* <td>{r.salaryBasic || 0}</td> */}
                        <td>
                          {salaryShown[r.employeeId]
                            ? "" // ⭐ Do not show salary again
                            : (salaryShown[r.employeeId] = r.salaryBasic || 0)}
                        </td>
                        <td>{r.accountNumber}</td>
                        <td>
                          <span
                            className={`badge ${
                              r.status === "PASSED" ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {r.status}
                          </span>
                        </td>
                        <td>
                          {r.issues && r.issues.length
                            ? r.issues.join(", ")
                            : "-"}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
